/**
 * Carrega o dataset de expedição uma vez por tela e separa carregando / erro /
 * dado (Task 14). Mesmo papel do `OrdersBoundary`: nenhuma tela de expedição
 * repete essa lógica nem confunde erro de carga com "nenhuma expedição".
 *
 * Migrado para `.tsx`/JSX real (Cluster D — Logística & Garantias, redesign
 * por perfil; ver `docs/architecture/ADR-0011-*.md`). Mudança de sintaxe
 * apenas (`createElement` → JSX) — nenhum ícone foi adicionado aqui: o
 * componente só delega para `StatusPanel`, que já carrega o ícone de cada
 * `kind` internamente (mesmo tratamento dado a `OrdersBoundary`/
 * `DatasetBoundary` nos Clusters A/B).
 */
// Import explícito de `React` — `tsx --test` (motor de `npm test`) cai no
// transform JSX clássico mesmo com `jsx: "react-jsx"` no tsconfig do app, e
// falha em runtime com "React is not defined" sem este import (ver ADR-0011).
import React, { type ReactElement } from "react";
import { StatusPanel, errorDetail } from "./StatusPanel.js";
import { useFulfillmentDataset } from "../queries.js";
import type { FulfillmentDataset } from "../fulfillment/dataset.js";

export interface FulfillmentBoundaryProps {
  children: (dataset: FulfillmentDataset) => ReactElement;
}

export function FulfillmentBoundary({ children }: FulfillmentBoundaryProps): ReactElement {
  const query = useFulfillmentDataset();
  if (query.isPending) {
    return <StatusPanel kind="loading" title="Carregando a fila de expedição…" />;
  }
  if (query.error) {
    return <StatusPanel kind="error" title="Não foi possível carregar a expedição" detail={errorDetail(query.error)} />;
  }
  if (!query.data) {
    return <StatusPanel kind="empty" title="Nenhum dado de expedição retornado pela API da Plataforma" />;
  }
  return children(query.data);
}
